import { isEmpty } from "lodash";
import DebugLogger from "../../utils/DebugLogger";
import * as Helper from "../../utils/Helper";
import MessageBox from "../ui/MessageBox";
import BaseView from "./BaseView";

class BaseComponent extends BaseView {
    get reducer() {
        throw new Error("Not implemented.");
    }

    get actionHandlers() {
        return {};
    }

    constructor(props) {
        super(props);

        DebugLogger.log("Lifecycle: " + this.viewName + " is created.");

        if (this.reducer) {
            DebugLogger.log("Lifecycle: register reducer for " + this.viewName);

            this.reducer.register();
        }
    }

    partnerRole = {
        ManagerPartner: 0,
        EditorPartner: 1,
        AssistantPartner: 2,
    };

    get isAdmin() {
        return Helper.isAdmin(this.props.user) || Helper.isGeneralAdmin(this.props.user);
    }

    get isEmployee() {
        return Helper.isEmployee(this.props.user);
    }

    get isRegionAdmin() {
        return Helper.isRegionAdmin(this.props.user);
    }

    get isRegionUser() {
        return Helper.isRegionUser(this.props.user);
    }
  
    componentDidMount() {
        super.componentDidMount();

        DebugLogger.log("Lifecycle: " + this.viewName + " is mounted.");
    }

    componentDidUpdate(prevProps) {
        if (prevProps.localState && this.props.localState) {
            var preAction = prevProps.localState.action;
            var curAction = this.props.localState.action;
            if (curAction) {
                var preAction = prevProps.localState.executedActions ? prevProps.localState.executedActions[curAction.type] : null;
                if (preAction && curAction) {
                    if (curAction.isDone) {
                        if (!preAction.isDone) {
                            if (this.componentHandleActionDone) {
                                this.componentHandleActionDone(curAction, this.props);
                            }
                        }
                    } else if (curAction.error) {
                        if (!preAction.error) {
                            if (this.componentHandleActionError) {
                                this.componentHandleActionError(curAction, this.props);
                            }
                        }
                    }
                }
            }
        }

        // we only process the error one time
        // handle general errors for now
        // if there are no general errors, but only action errors,
        // we will not need this part of logic any more
        if (!prevProps.localState.error && this.props.localState.error) {
            if (this.componentHandleError) this.componentHandleError(this.props.localState.error, this.props);
            else this.displayError(this.props.localState.error); // by default, we display error in a message box
        }
    }

    componentWillUnmount() {
        if (this.reducer) {
            DebugLogger.log("Lifecycle: unregister reducer for " + this.viewName);

            this.reducer.unregister();
        }

        DebugLogger.log("Lifecycle: " + this.viewName + " is destroyed.");
    }

    componentHandleActionDone(action, props) {
        if (!isEmpty(action.type)) {
            if (this.actionHandlers[action.type]) {
                if (this.actionHandlers[action.type].done) {
                    this.actionHandlers[action.type].done(action, props);
                }
            }
        }
    }

    componentHandleActionError(action, props) {
        if (!isEmpty(action.type)) {
            if (this.actionHandlers[action.type]) {
                if (this.actionHandlers[action.type].error) {
                    this.actionHandlers[action.type].error(action, props);
                }
            }
        }
    }

    getExecutedAction(actionType) {
        if (this.props && this.props.localState && this.props.localState.executedActions) {
            return this.props.localState.executedActions[actionType];
        }

        return null;
    }

    isActionExecuting(actionType) {
        if (this.props && this.props.localState && this.props.localState.executedActions) {
            var action = this.props.localState.executedActions[actionType];
            return action ? action.isExecuting : false;
        }

        return false;
    }

    isActionDone(actionType) {
        if (this.props && this.props.localState && this.props.localState.executedActions) {
            var action = this.props.localState.executedActions[actionType];
            return action ? action.isDone : false;
        }

        return false;
    }

    displayError(error) {
        if (!error) {
            return; // do nothing
        }

        var newError = { ...error };
        if (error.code || error.code === 0) {
            newError.message = error.message + " (code: " + error.code + ")";
        }

        MessageBox.danger({
            text: newError.message,
            duration: 5000,
        });
    }

    displaySuccess(info) {
        if (!info) {
            return; // do nothing
        }

        MessageBox.success({
            text: info.message || info,
            duration: 5000,
        });
    }
}

export default BaseComponent;
